<template lang="html">
  <transition>
    <div class="timeTrack" v-if="this.$store.state.currentTrackingId !== -1">
      <div class="contentWrapper">
        <AveBigIcon icon="timetracking" :darkmode="darkmode" @click.native="stopTracking"/>
        <div class="gap">
        </div>
        <section class="description">
          <p class="title">
            {{trackingTitle}}
          </p>
          <p class="description">
            {{`${donetime}h of ${timeToFinish}h`}}
          </p>
        </section>
      </div>
        <svg class="progress" width="100%" height="5px">
          <rect class="progressbar" :width="width" :class="{overTime: this.$store.state.currentTrackingDoneTime > this.$store.state.currentTrackingTime}"></rect>
        </svg>
    </div>
  </transition>
</template>

<script>
import AveBigIcon from '@/components/AveBigIcon.vue';

export default {
  name: 'Components',
  components: {
    AveBigIcon,
  },
  computed: {
    trackingTitle() {
      return this.$store.state.currentTrackingTitle;
    },
    donetime() {
      const donetime = this.formatTime(this.$store.state.currentTrackingDoneTime);
      return donetime;
    },
    timeToFinish() {
      return this.formatTime(this.$store.state.currentTrackingTime);
    },
    width() {
      // // console.log(`${(this.donetime / this.time) * 100}%`);
      // // console.log(this.donetime);
      // // console.log(this.$store.state.currentTrackingTime);
      return `${(this.$store.state.currentTrackingDoneTime / this.$store.state.currentTrackingTime) * 100}%`;
    },
  },
  data() {
    return {
    };
  },
  methods: {
    formatTime(input) {
      const milli = input;
      // const MILLITOHOURS = 3600000;
      // const MILLITOMINUTES = 60000;
      // const MILLITOSECONDS = 1000;
      const hours = milli / 3600000;
      const totalHours = Math.floor(hours);
      const h = totalHours > 9 ? totalHours : `0${totalHours}`;

      const minutes = (hours - totalHours) * 60;
      const totalMinutes = Math.floor(minutes);
      const m = totalMinutes > 9 ? totalMinutes : `0${totalMinutes}`;

      const seconds = (minutes - totalMinutes) * 60;
      const totalSeconds = Math.floor(seconds);
      const s = totalSeconds > 9 ? totalSeconds : `0${totalSeconds}`;
      return `${h}:${m}:${s}`;
    },
    stopTracking() {
      this.$store.dispatch('stopTracking');
    },
  },
  props: {
    darkmode: Boolean,
    // trackedTime: Number,
    // formatTrackedTime: {
    //   type: String,
    //   default: '00:00:00',
    // },
    // time: {
    //   type: Number,
    //   default: 12,
    // },
    // title: {
    //   type: String,
    //   default: 'Uups and error occured',
    // },
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.timeTrack.v-enter-active,
.timeTrack.v-leave-active {
  transition: top 350ms ease;
}

.timeTrack.v-enter,
.timeTrack.v-leave-to {
  top: -200px;
}

.timeTrack
  background-color: $normal
  color $darkmodeWhite
  display: block
  position: fixed;
  top:0;
  width:100%
  height:93px
  z-index: 1

  .contentWrapper
    display: flex
    align-items: center
    justify-content: center;
    margin: auto
    margin-top: 12px;
    margin-bottom: 12px;

    .icon
      width:33px

    .gap
      width:6%

    .title
      margin: 0 0 0 0
      font-size: 13pt;

    .description
      margin: 0 0 0 0
      font-size: 11pt

.progress
  margin: 0
  padding: 0
  background-color: $darkmodeWhite
  width:100%

  .progressbar
    fill: $positive;
    margin: 0
</style>
